import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import BlogPost from "@/pages/BlogPost";

export const Route = createFileRoute("/zh-cn/blog/$slug")({
  loader: ({ params }) => loadContentMeta("blog_posts", params.slug, "zh-cn"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/zh-cn/blog/${params.slug}`, loaderData, /^eudravigilance-signal-management-approaches(?:-zh)?$/.test(params.slug) ? {
      title: "EudraVigilance 信号管理：选择适合的方法 | QbD Group",
      description: "了解将 EudraVigilance 数据纳入信号管理的三种方法，从验证和评估到基于风险的检测与监测。",
    } : /^eu-variations-grouping-worksharing-guide(?:-zh)?$/.test(params.slug) ? {
      title: "欧盟变更：分组与工作分享实用指南 | QbD Group",
      description: "了解如何根据 2025 年欧盟变更指南运用分组与工作分享，协调申报并改善生命周期规划。",
    } : {}),
  component: BlogPost,
});

